import type { UserTrainingMedia } from '@cobliteam/api-lib/src/__generated__/graphql';

/**
 * Aplica no cache o registro devolvido pela mutação, inserindo quando ainda não existe.
 *
 * O `map` que havia antes só atualizava vídeos que o usuário já tinha assistido alguma vez: na primeira
 * vez não há entrada para aquele `trainingMediaId`, então o resultado saía idêntico ao anterior e a tag
 * seguia "Não assistido" até um reload (AE-2521).
 *
 * Fica em arquivo próprio (e não no hook) para ser testável sem carregar a cadeia de api-lib.
 */
const upsertUserTrainingMedia = (list: UserTrainingMedia[] | undefined, entry: UserTrainingMedia) => {
  if (!list) return list;
  const index = list.findIndex((userMedia) => userMedia.trainingMediaId === entry.trainingMediaId);
  if (index === -1) return [...list, entry];
  return list.map((userMedia, position) => (position === index ? entry : userMedia));
};

export default upsertUserTrainingMedia;
